import {
    HISTORY_ACTIONS_LOADED,
    HISTORY_ACTIONS_LOADING,
    HISTORY_ITEM_LOADED,
    HISTORY_ITEM_LOADING,
    HISTORY_LOADED,
    HISTORY_LOADING,
    HISTORY_PAGE_OPENED
} from "./actionTypes";
import axios from "axios";
import {getConfig} from "./authActions";
import {returnErrors} from "./errorActions";
import {getIsoLocalString} from "../utils/dateUtils";
import {getPartnerId, isAdmin} from "../utils/authUtils";
import {pathParameter} from "../utils/urlUtils";
import {notEmptyString} from "../utils/stringUtils";


export const loadHistory = (selectedFromDate, selectedToDate, searchData, callbackFunction) => (dispatch, getState) => {

    dispatch({type: HISTORY_LOADING});
    const fromDate = selectedFromDate ? "?from=" + getIsoLocalString(selectedFromDate) : "";
    const toDate = selectedToDate ? "&to=" + getIsoLocalString(selectedToDate) : "";
    const userName = notEmptyString(searchData?.userName) ? "&userName=" + searchData.userName : "";
    const forUserName = notEmptyString(searchData?.forUserName) ? "&forUserName=" + searchData.forUserName : "";
    const message = notEmptyString(searchData?.message) ? "&message=" + searchData.message : "";
    const ip = notEmptyString(searchData?.ip) ? "&ip=" + searchData.ip : "";
    const ua = notEmptyString(searchData?.userAgent) ? "&userAgent=" + searchData.userAgent : "";
    const objectActionIds = searchData?.objectActionIds ? "&objectActionIds=" + searchData?.objectActionIds : "";
    const userIds = searchData?.userIds ? "&userIds=" + searchData?.userIds : "";
    const forUserIds = searchData?.forUserIds ? "&forUserIds=" + searchData?.forUserIds : "";

    axios
        .get(process.env.REACT_APP_API_URL + '/history' + fromDate + toDate + userName + forUserName + message + ip + ua + objectActionIds + userIds + forUserIds, getConfig(getState))
        .then(res => {
                dispatch({
                    type: HISTORY_LOADED,
                    payload: res.data
                })
            }
        )
        .then(() => callbackFunction && callbackFunction())
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const loadHistoryItem = (id, callbackFunction) => (dispatch, getState) => {

    dispatch({type: HISTORY_ITEM_LOADING});

    axios
        .get(process.env.REACT_APP_API_URL + '/history/' + id, getConfig(getState))
        .then(res => {
                dispatch({
                    type: HISTORY_ITEM_LOADED,
                    payload: res.data
                })
            }
        )
        .then(() => callbackFunction && callbackFunction())
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const openPage = () => (dispatch, getState) => {
    if (isAdmin()) {
        return;
    }
    const pageName = window.location.pathname;
    const tabName = pathParameter("type") || "";
    const partnerId = getPartnerId() || "";
    axios
        .post(process.env.REACT_APP_API_URL + '/history/page' + '?pageName=' + pageName + '&tabName=' + tabName + '&partnerId=' + partnerId, getConfig(getState))
        .then(res => {
                dispatch({
                    type: HISTORY_PAGE_OPENED,
                    payload: res.data
                })
            }
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const loadActionsFilters = (callbackFunction) => (dispatch, getState) => {

    dispatch({type: HISTORY_ACTIONS_LOADING});

    axios
        .get(process.env.REACT_APP_API_URL + '/history/filters/actions', getConfig(getState))
        .then(res => {
                dispatch({
                    type: HISTORY_ACTIONS_LOADED,
                    payload: res.data
                })
            }
        )
        .then(() => callbackFunction && callbackFunction())
        .catch(err => {
            dispatch(returnErrors(err));
        });
};